let charMobile = 300;
let charDesktop = 750;
let shrinkables = document.querySelectorAll('.readmore');

if (shrinkables.length > 0) {
    for (let i = 0; i < shrinkables.length; i++) {
        let viewport = window.matchMedia('(max-width: 1024px)');
        let element = shrinkables[i].innerHTML;

        if (element.length > charMobile && viewport.matches) {
            let truncateMobile = element.substring(0, charMobile).replace(/\w+$/, '');
            let remainder = "";
            let id = shrinkables[i].id;

            remainder = element.substring(charMobile, element.length);

            shrinkables[i].innerHTML = '<span>' + truncateMobile + '<span class="hidden" id="' + id + 'Overflow">'+ remainder +'</span></span><a id="' + id + 'MoreLink" href="#!" onclick="showMore(\''+ id + '\');" class="inline-block mt-2 font-bold text-yellow underline cursor-pointer">Baca Selengkapnya</a><a class="hidden" href="#!" id="' + id + 'LessLink" onclick="showLess(\''+ id + '\');">Baca Lebih Ringkas</a>';
        } else if (element.length > charDesktop) {
            let truncateDesktop = element.substring(0, charDesktop).replace(/\w+$/, '');
            let remainder = "";
            let id = shrinkables[i].id;

            remainder = element.substring(charMobile, element.length);

            shrinkables[i].innerHTML = '<span>' + truncateDesktop + '<span class="hidden" id="' + id + 'Overflow">'+ remainder +'</span></span><a id="' + id + 'MoreLink" href="#!" onclick="showMore(\''+ id + '\');" class="inline-block mt-2 font-bold text-yellow underline cursor-pointer">Baca Selengkapnya</a><a class="hidden" href="#!" id="' + id + 'LessLink" onclick="showLess(\''+ id + '\');">Baca Lebih Ringkas</a>';
        }
    }
}